import { render, staticRenderFns } from "./LensSpendBackEmptyState.vue?vue&type=template&id=f2b4c726&scoped=true"
import script from "./LensSpendBackEmptyState.vue?vue&type=script&lang=js"
export * from "./LensSpendBackEmptyState.vue?vue&type=script&lang=js"
import style0 from "./LensSpendBackEmptyState.vue?vue&type=style&index=0&id=f2b4c726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b4c726",
  null
  
)

export default component.exports